/** The storefront's error page (its own module: the page is in every route's browser bundle). */
export const shopError = {
    title: "Something went wrong",
    body: "Please try again in a moment.",
    retry: "Try again",
};
//# sourceMappingURL=shop-error.js.map